import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
/* IMPORT HERE */

const processes: ThemeUICSSObject = {
  variant: 'layout.common.modals.dateReasignment',
  display: 'flex',
  justifyContent: responsive({
    0: 'center !important',
    5: 'space-evenly !important',
  }),
  flexDirection: responsive({
    0: 'column',
    5: 'row',
  }),
  '.rollbackTable__container': {
    paddingTop: '5',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: responsive({
      0: 'center !important',
      5: 'start !important',
    }),
    alignItems: responsive({
      0: 'center !important',
      5: 'space-between !important',
    }),
    width: responsive({
      0: '100%',
      5: '48%',
    }),
  },

  '.rollbackTable__box': {
    width: responsive({
      0: '80%',
      5: '100%',
    }),
  },

  '.rollbackTable__table': {
    variant: 'layout.common.tables.primary',
    tableLayout: 'auto',
    width: '100%',
  },

  '.rollbackTable__table thead tr:not(.filtersRow):not(.responsiveTable__filters__row) th button:not(.iconButton):not(.delete_date_button).headButtonRollback':
    {
      justifyContent: 'center',
      padding: spacing(4),
      width: 'max-content',
    },

  '&.hourInput': {
    height: '50px',
    justifyContent: 'start !important',
    input: {
      textAlign: 'center',
      height: '50px',
      width: '10ch',
    },
  },
  '.changeDate__Wrapper': {
    display: 'flex',
  },
  '&.roles__wrapper': {
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  '&.ReasignModal .responsiveTable__wrapper': {
    overflowY: 'scroll',
    height: '170px',
    overflowX: 'hidden',
  },
  '.modalButton': {
    width: '100% !important',
  },
  'tbody tr[aria-selected="true"]': {
    backgroundColor: 'rgb(221, 235, 245)',
  },
  '.AdHoc__Radios': {
    display: 'flex',
  },
  '&.twoTables__AdHocContainer': {
    display: 'flex',
    flexDirection: 'column',
    div: {
      paddingTop: spacing(3),
    },
    ul: {
      justifyContent: 'space-around !important',
    },
  },
  '&.radios__AdHocContainer > div': {
    justifyContent: 'center',
    display: 'flex',
  },
};

export default processes;
